import React, { FC, ReactElement } from 'react';
import { Fail } from 'b2b-apps/shop/common/components/Fail';
import { ServerFail } from 'b2b-apps/shop/common/components/ServerFail';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { WithFailHandlerType } from './withFailHandler.types';

const withFailHandler = <
  P,
  R extends RemoteRecord<any> = RemoteRecord<any>,
  E extends Record<string, any> = Record<string, any>,
>(
    getRemoteRecords: (props: P) => R[],
    ErrorComponent?: FC<E & { remoteRecord: R }>,
    getErrorComponentProps: (props: P) => E = (props: P) => ({} as E),
  ): WithFailHandlerType<P> => (Component) => {
    const WithFailHandler = (props: P): ReactElement => {
      const remoteRecords = getRemoteRecords(props);

      for (const remoteRecord of remoteRecords) {
        const { hasFailed, hasServerError, error } = remoteRecord;

        if (hasFailed) {
          if (ErrorComponent) {
            const errorComponentProps = getErrorComponentProps(props);

            return (
              <ErrorComponent {...errorComponentProps} remoteRecord={remoteRecord} />
            );
          }

          return hasServerError
            ? <ServerFail error={error} isMessage={false} />
            : <Fail error={error} />;
        }
      }

      return <Component {...props} />;
    };

    return WithFailHandler;
  };

export { withFailHandler };
